import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, ReplaySubject } from 'rxjs';
import { EncrDecrService } from './EncrDecrService.service';
import { map, take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor(private http: HttpClient, private encrDecrService: EncrDecrService) { }

  //get(route: string, isencrypt = true, isDecrypt = true): any {

  //  //let payload;
  //  //if (isencrypt) {
  //  //  payload = {
  //  //    requestbody: this.encrDecrService.set(body)
  //  //  }
  //  //} else {
  //  //  payload = body;
  //  //}

  //  return this.http.get(route, { responseType: "text" }).pipe(map(response => {
  //    if (isDecrypt) {
  //      response = this.encrDecrService.get(response);

  //      response = JSON.parse(response);
  //    }
  //    return response;
  //  }));
  //}

  get2(route: string, params?: any): any {
    debugger
    return this.http.get<any>(route, { params: params }).pipe(map((response: any) => {
      debugger;
      response = this.encrDecrService.get(response);
      response = JSON.parse(response);
      return response;
    }));
  }

  get(route: string, params?: any, header?: any): any {
    debugger
    return this.http.get(route, { responseType: "text" }).pipe(map(response => {
      debugger
      response = this.encrDecrService.get(response);

      response = JSON.parse(response);

      return response;
    }));
  }

  post(route: string, body: any, isencrypt = true, isDecrypt = true): any {
    let payload;
    if (isencrypt) {
      payload = {
        requestbody: this.encrDecrService.set(body)
      }
    } else {
      payload = body;
    }
    debugger;
    return this.http.post<any>(route, payload).pipe(map(response => {
      debugger;

      if (isDecrypt) {
        // try {
        response = this.encrDecrService.get(response);
        debugger;
        //response = JSON.parse(response);
        //}
        //catch (e) {
        //  debugger;
        //  console.log(e);
        //}

      }
      return response;
    }));
  }

  post2(route: string, body: any, header: any, isencrypt = true, isDecrypt = true): any {
    let payload;
    if (isencrypt) {
      payload = {
        requestbody: this.encrDecrService.set(body)
      }
    } else {
      payload = body;
    }
    debugger;
    return this.http.post<any>(route, payload, header).pipe(map((response: any) => {
      debugger;

      if (isDecrypt) {
        // try {
        response = this.encrDecrService.get(response);
        debugger;
        response = JSON.parse(response);
        //}
        //catch (e) {
        //  debugger;
        //  console.log(e);
        //}

      }
      return response;
    }));
  }

}


@Injectable()
export class CommonService {

  invokeEvent: Subject<any> = new Subject();

  callMethodOfSecondComponent() {
    this.invokeEvent.next(true);
  }



}
@Injectable()
export class CommonService1 {
  notificationinvokeEvent: Subject<any> = new Subject();


  callMethodOfNotificationComponent() {
    this.notificationinvokeEvent.next(true);
  }
}

@Injectable()
export class CommonService2 {
  BalinvokeEvent: Subject<any> = new Subject();


  callMethodOfBalComponent() {
    this.BalinvokeEvent.next(true);
  }
}






@Injectable()
export class CartService {

  array: any = [];

  array2: any = [];

  constructor(private toastr: ToastrService, private router: Router) {


  }

  invokeEvent: Subject<any> = new Subject();

  callMethodOfSecondComponent() {
    this.invokeEvent.next(true);
  }

  private itemsSubject = new BehaviorSubject<any[]>([]);
  items$ = this.itemsSubject.asObservable();

  addToCart(ParentproductId: any): any {
    debugger;


    if (!this.array.includes(ParentproductId)) {


      this.array.push(ParentproductId);
      sessionStorage.setItem('products', JSON.stringify(this.array));
      this.toastr.success("Product Add Successful To Cart", 'Success');
      

    }
    else {

      this.toastr.error("Product Already Add To Cart", 'Error');

    }
  }



  removeToCart(ParentproductId: any) {

    debugger
    if (this.array.includes(ParentproductId)) {
      debugger;


      this.array.splice(this.array.indexOf(ParentproductId), 1);

      sessionStorage.setItem('products', JSON.stringify(this.array));
      this.toastr.success("Product Remove To Cart", 'Success');
      //this.router.navigate(['/Cart'], { queryParams: { serviceCode: null }, skipLocationChange: true });

    }
  }

  getItems() {


    if (sessionStorage.getItem('products')) {
     
      this.array = this.getUser(); 

    }
    else {
      this.array = [];
    }
  
    const itemCount2 = this.array.length;
    

    return itemCount2;
  }


  getparentproductid() {


    if (sessionStorage.getItem('products')) {
      //exist data on storage
      //so grab the storage
      this.array2 = this.getUser(); 

    }
    else {
      this.array2 = [];
    }
    return this.array2;
  }


  public getUser(): any {

    const user = sessionStorage.getItem('products');

    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  public getToken(): string | null {
    return sessionStorage.getItem('auth-token');
  }



  removeToCartafterurl() {

    this.array = [];

    sessionStorage.removeItem('products');

  }
  
}
